import { Dispatch } from 'redux'
import { API } from 'network'
import {
  IGetBusinessEntityParams,
  IPutBusinessEntityParams,
  TPutBusinessEntitySalesReactivationParams,
} from 'models/BusinessEntity'
import { NotificationManager } from 'helpers/NotificationsManager'
import { ThunkAction } from 'redux-thunk'
import { handleErrorNotification } from 'services/ErrorHandlingService'
import {
  GetBusinessEntityAction,
  GetBusinessEntityErrors,
  BusinessEntityFetching,
  UpdateBusinessEntity,
} from './actions'

export type BusinessEntityActions =
  | ReturnType<typeof GetBusinessEntityAction>
  | ReturnType<typeof GetBusinessEntityErrors>
  | ReturnType<typeof BusinessEntityFetching>
  | ReturnType<typeof UpdateBusinessEntity>

export const getBusinessEntity =
  (id: number, params?: IGetBusinessEntityParams) =>
  async (dispatch: Dispatch<BusinessEntityActions>) => {
    let response
    dispatch(BusinessEntityFetching(true))
    try {
      response = await API.BusinessEntities.getBusinessEntity(id, {
        ...params,
      })
      dispatch(GetBusinessEntityAction(response))
    } catch (error) {
      response = error
      dispatch(GetBusinessEntityErrors({ code: error.code, message: error.message }))
    } finally {
      dispatch(BusinessEntityFetching(false))
    }
  }

export const putBusinessEntity =
  (id: number, params: IPutBusinessEntityParams) =>
  async (dispatch: Dispatch<BusinessEntityActions>) => {
    try {
      const response = await API.BusinessEntities.putBusinessEntity(id, {
        ...params,
      })
      dispatch(UpdateBusinessEntity(response))
      NotificationManager.success('Business entity updated successfully.')
      return response
    } catch (error) {
      const { code, message } = error
      dispatch(
        GetBusinessEntityErrors({
          code,
          message,
        })
      )
      handleErrorNotification(error)
      throw Error(error)
    }
  }

export const updateBusinessEntity =
  (
    id: number,
    params: IPutBusinessEntityParams
  ): ThunkAction<Promise<BusinessEntityActions['payload']>, any, any, BusinessEntityActions> =>
  async (dispatch) => {
    try {
      const response = await API.BusinessEntities.updateBusinessEntity(id, {
        ...params,
      })
      NotificationManager.success('Business entity updated successfully.')
      dispatch(UpdateBusinessEntity(response))
      return response
    } catch (error) {
      dispatch(GetBusinessEntityErrors({ code: error.code, message: error.message }))
      handleErrorNotification(error)
      return error
    }
  }

export const updateBusinessEntitySalesReactivation =
  (id: number, params: TPutBusinessEntitySalesReactivationParams) =>
  async (dispatch: Dispatch<BusinessEntityActions>) => {
    try {
      const response = await API.BusinessEntities.putBusinessEntitySalesReactivation(id, params)
      dispatch(UpdateBusinessEntity(response))
      NotificationManager.success('Business entity updated successfully.')
      return response
    } catch (error) {
      const { code, message } = error
      dispatch(
        GetBusinessEntityErrors({
          code,
          message,
        })
      )
      handleErrorNotification(error)
      throw Error(error)
    }
  }
